import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Request a quote",
    desc: "Share a few details. No call center. No chatbot maze.",
  },
  {
    n: "02",
    title: "We compare top carriers",
    desc: "40+ carriers, quietly weighed against your exact needs.",
  },
  {
    n: "03",
    title: "You get the best option",
    desc: "One clean recommendation — with the trade-offs laid bare.",
  },
  {
    n: "04",
    title: "We handle everything",
    desc: "Signing, activation, claims, renewals. You just live your life.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="section-process"
      className="bg-white border-t border-neutral-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14" data-reveal>
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-6">
              How it works
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] text-black leading-[1.02]">
              Four steps.
              <br />
              <span className="italic font-medium">Zero friction.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pl-10 lg:border-l lg:border-neutral-200">
            <p className="text-neutral-600 leading-relaxed max-w-md text-[15px]">
              From first message to final policy, our process is designed to
              feel less like insurance and more like working with a trusted
              advisor on your side.
            </p>
          </div>
        </div>

        <div className="border-t border-neutral-200" data-reveal-group>
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              data-reveal-child
              data-reveal-delay={i + 1}
              className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 border-b border-neutral-200 group hover:bg-neutral-50 transition-colors"
            >
              <div className="col-span-2 md:col-span-2">
                <div className="font-display text-4xl md:text-7xl font-light text-neutral-300 group-hover:text-black transition-colors tracking-tight leading-none">
                  {s.n}
                </div>
              </div>
              <div className="col-span-10 md:col-span-7">
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-black tracking-[-0.01em]">
                  {s.title}
                </h3>
                <p className="mt-3 text-neutral-600 text-[15px] md:text-base leading-relaxed max-w-lg">
                  {s.desc}
                </p>
              </div>
              <div className="hidden md:flex col-span-3 items-end justify-end text-xs uppercase tracking-[0.2em] text-neutral-400">
                Step {i + 1} of {STEPS.length}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
